




















import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CreatePhaseStatusVerticalStep3 extends Vue {
    @Prop({ required: true }) readonly currentStep!: number
    @Prop({ default: false }) readonly existing!: boolean
    @Prop({ required: true }) readonly value!: RealworksStatusRule

    get applyToTriggeredReferrals() {
        if (this.value.applyToTriggeredReferrals === true) {
            return 'Ja'
        } else {
            return 'Nee'
        }
    }

    get applyToTriggeredReferralsPastDays() {
        return this.$t('virtualColleague.phaseStatus.sideBar.applyToTriggeredReferralsPastDaysLabel', {
            days: this.value.applyToTriggeredReferralsPastDays,
        })
    }

    get supportsTriggeredReferrals(): boolean {
        return true
    }

    get supportsTriggeredReferralsPastDays(): boolean {
        return ['agendaTypes', 'taakTypes'].includes(this.value.triggerType)
    }
}
